import React from 'react';
import styles from './styles.scss';

import { DisplayLink } from '@xo-union/tk-ui-links';

export const LegalDisclosure: React.FC = () => {
  return (
    <div className={styles.legalDisclosure}>
      Don't share sensitive info. Chats may be reviewed. See {''}
      <DisplayLink href="https://www.theknotww.com/terms-of-use/">Terms</DisplayLink> and{' '}
      <DisplayLink href="https://www.theknotww.com/privacy-policy/">Privacy Policy</DisplayLink>.{' '}
    </div>
  );
};
